import {Component, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {Operacao} from '../../../model/catalogo';
import {CatalogoApiService} from './../../../service/api/catalogo.api';
import {GlobalService} from './../../../service/global.service';
import {ModalService} from '../../../service/modal.service';
import {DetalhamentoApiService} from './../../../service/api/detalhamento.api';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {TipoEstado} from '../../../model/constantes';
import {ConstantesApiService} from '../../../service/api/constantes.api';
import {IMyDpOptions} from 'mydatepicker';
import {Router} from '@angular/router';
import {
    FiltroAlteracaoEstado,
    FiltrosDeOperacao,
    FiltroOperacao,
    ResultadoFiltroDetalhaOperacao,
    FiltroMetadata,
    ResultadoFiltroOperacao
} from './../../../model/filtros';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Component({
    selector: 'operacao',
    templateUrl: './operacao.component.html',
    styleUrls: ['./operacao.component.css', '../artefato.css']
})

export class ArtefatoOperacaoComponent {

    resultados: ResultadoFiltroOperacao = new ResultadoFiltroOperacao();
    estados: Array<TipoEstado> = new Array<TipoEstado>();

    //filtros
    codigo = new FormControl('', []);
    estado = new FormControl('0', []);
    alteracaoEstado = new FormControl('', []);
    versao = new FormControl('', []);
    descricao = new FormControl('', []);
    matricula = new FormControl('', []);
    nome = new FormControl('', []);
    dtInicio = new FormControl('', []);
    dtFim = new FormControl('', []);
    irpagina = new FormControl('', []);

    filtroNome: String = '';
    hoje: Date = new Date();

    //paginacao
    pagina: number = 1;

    //resultado filtro
    detalhes: ResultadoFiltroDetalhaOperacao = new ResultadoFiltroDetalhaOperacao();

    constructor(
        private modalService: ModalService,
        private router: Router,
        private constantesService: ConstantesApiService,
        public pesquisaService: PesquisasFiltroApiService,
        public catalogoService: CatalogoApiService,
        public globalService: GlobalService,
        public detalhamentoApiService: DetalhamentoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                this.pesquisar();
            }
        }
    }

    ngOnInit() {
        this.constantesService.buscaTipoEstado(0)
            .subscribe(estados => this.estados = estados as Array<TipoEstado>);
        this.pesquisar();
    }

    public myDatePickerOptions: IMyDpOptions = {
        // dateFormat: 'dd/mm/yyyy',
        dateFormat: 'yyyy-mm-dd',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: true,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    detalhar(codigo, versao) {
        this.detalhamentoApiService.detalhaOperacao(codigo, versao)
            .subscribe(response => {
                    this.detalhes = response;
                    $('#detalheModal').modal('show');
                },
                erro => {
                });
    }

    editar(codigo: number, versao: number) {
        this.router.navigate(['/cadastro-operacao', codigo, versao]);
    }

    editarParametroEntrada(codigo: number, versao: number) {
        this.modalService.abrirPaginaModal('parametro-entrada-modal', {}, {
                'pesquisar': false,
                'mensagem': '',
                'codigo': codigo,
                'versao': versao
            },
            'Editar conteúdo padrão !', 'Fechar')
            .subscribe(res => {
                // if(res.tipoEdicao) {
                //     this.tipoEdicao = "editar"
                // } else {
                //     this.tipoEdicao = "nova"
                // }
                // this.salvarLayout();
            });
    }

    excluir(codigo: number, versao: number) {
        let msgSucesso = 'Operação removida com sucesso.';
        let msgErro = 'Ocorreu um erro ao remover a operação.';
        this.catalogoService.removeOperacao(codigo, versao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.pesquisar();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    }
                }
            );
    }

    novo() {
        this.router.navigate(['/cadastro-operacao']);
    }

    pesquisar() {
        this.globalService.loading = true;
        this.pesquisaService.mudarPagina(this.pagina);
        this.pesquisaService.filtraOperacaoPaginado(this.getFiltros())
            .subscribe(
                listaItens => {
                    this.resultados = listaItens as ResultadoFiltroOperacao;
                    this.globalService.loading = false;
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404) {
                        this.resultados.operacoes = new Array<Operacao>();
                    }
                }
            );
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina++;
        this.pesquisar();
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina--;
        this.pesquisar();
    }


    IrparaPargina() {
        if (this.irpagina.value != 0) {
            this.pagina = this.irpagina.value;
            this.pesquisar();
        }
    }

    getFiltros() {
        let filtros = new FiltrosDeOperacao();
        let filtroOperacao = new FiltroOperacao();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;

        // filtro servico
        if (this.codigo.value != '') {
            filtroOperacao.codigo = this.codigo.value;
        }
        if (this.versao.value != '') {
            filtroOperacao.versao = this.versao.value;
        }
        if (this.nome.value != '') {
            filtroOperacao.nome = this.nome.value;
        }
        if (this.estado.value != '' && this.estado.value != '0') {
            filtroOperacao.codTipoEstado = this.estado.value;
        }
        if (this.descricao.value != '') {
            filtroOperacao.descricao = this.descricao.value;
        }

        // filtro alteracao estado
        if (this.alteracaoEstado.value != '' && this.alteracaoEstado.value != '0') {
            filtroAlteracaoEstado.codTipoEstado = this.alteracaoEstado.value;
        }
        if (this.matricula.value != '') {
            filtroAlteracaoEstado.matricula = this.matricula.value;
        }
        if (this.dtInicio.value != '') {
            filtroAlteracaoEstado.dataInicial = this.dtInicio.value.formatted;
        }
        if (this.dtFim.value != '') {
            filtroAlteracaoEstado.dataFinal = this.dtFim.value.formatted;
        }

        filtros.filtroOperacao = filtroOperacao;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }


    alterarEstado(codigo, versao, tipoOperacao) {

        let msgSucesso = '';
        let msgErro = '';
        let msgAtualizacao = '';

        switch (tipoOperacao) {
            case 'despacha':
                msgSucesso = 'Operação despachada com sucesso.';
                msgErro = 'Ocorreu um erro ao despachar a operação.';
                msgAtualizacao = 'Item despachado pelo sistema de Administração Web.';
                break;
            case 'aprova':
                msgSucesso = 'Operação aprovada com sucesso.';
                msgErro = 'Ocorreu um erro ao aprovar a operação.';
                msgAtualizacao = 'Item aprovado pelo sistema de Administração Web.';
                break;
            case 'ativa':
                msgSucesso = 'Operação ativada com sucesso.';
                msgErro = 'Ocorreu um erro ao ativar a operação.';
                msgAtualizacao = 'Item ativado pelo sistema de Administração Web.';
                break;
            case 'inativa':
                msgSucesso = 'Operação inativada com sucesso.';
                msgErro = 'Ocorreu um erro ao inativar a operação.';
                msgAtualizacao = 'Item inativado pelo sistema de Administração Web.';
                break;
        }

        this.globalService.loading = true;
        this.catalogoService.alterarEstadoOperacao(codigo, versao, tipoOperacao, msgAtualizacao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.pesquisar();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    }
                }
            );

    }

    getEstado(codigo: Number) {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
        }
        return '-';
    }


    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }


}



// WEBPACK FOOTER //
// ./src/app/artefato/operacao/operacao.component.ts